'use client';

import { useTranslations } from 'next-intl';
import { Icon } from '@/lib/ui-kit/icons';
import { cn } from '@/lib/ui-kit/utils';

type OrderFormWarningProps = {
  variant?: 'insufficient' | 'swap';
  onDepositClick?: () => void;
  showDeposit?: boolean;
  className?: string;
};

export function OrderFormWarning({
  variant = 'insufficient',
  onDepositClick,
  showDeposit = true,
  className,
}: OrderFormWarningProps) {
  const t = useTranslations('orderForm');
  const message = variant === 'swap' ? t('swapFunds') : t('insufficientFunds');

  return (
    <div
      className={cn(
        'flex w-full items-center gap-2 rounded-[10px] bg-v2-surface-tertiary px-3 py-2',
        className,
      )}
    >
      <Icon name="Hexagon" size={20} className="shrink-0 text-red-400" />
      <span className="flex-1 text-[12px] leading-4 tracking-[-0.12px] text-v2-text-primary">
        {message}
      </span>
      {showDeposit && onDepositClick ? (
        <button
          type="button"
          onClick={onDepositClick}
          className="shrink-0 cursor-pointer rounded-[10px] p-2 text-[12px] leading-4 tracking-[-0.12px] text-v2-text-primary underline underline-offset-2 transition-opacity hover:opacity-80"
        >
          {t('deposit')}
        </button>
      ) : null}
    </div>
  );
}
